import { render } from "./Access.vue?vue&type=template&id=16266b70"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/web.digitalsystemsrl.it/web.digitalsystemsrl.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__